module.exports = __webpack_public_path__ + "static/media/sthetoscope2.abc6fa9e.jpg";